{
  "id": "nephthys",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Néftis",
    "en": "Nephthys"
  },
  "icon": "gods/nephthys",
  "portrait": "gods/nephthys-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "scorpion-man": 1
  },
  "unlocks": ["scorpion-man", "funeral-barge", "spirit-of-maat", "funeral-rites", "nebty"],
  "powers": ["ancestors"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Goddess of night and death. Focus: Pharaohs and Priests. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 180 s."
  }
}
